import { Order } from '~api/tos';

import { Card, ListLayout } from '@ingrid/luterkort-react';

import { LocalizedDate } from '~src/i18n/localized-date';
import { useTranslation } from '~src/i18n/use-translation';

interface Props {
  order: Pick<Order, 'created_at' | 'updated_at'>;
}

export function Details(props: Props) {
  const { order } = props;

  const { t } = useTranslation();

  return (
    <Card.Wrapper>
      <Card.Header>{t('common.details')}</Card.Header>
      <Card.Content>
        <ListLayout.Column>
          <ListLayout.Stack>
            <ListLayout.Text variant="secondary">{t('common.createdAt')}</ListLayout.Text>
            <ListLayout.Text variant="primary">
              {order.created_at ? <LocalizedDate dateTime={order.created_at} time /> : '-'}
            </ListLayout.Text>
          </ListLayout.Stack>

          <ListLayout.Stack>
            <ListLayout.Text variant="secondary">{t('common.updatedAt')}</ListLayout.Text>
            <ListLayout.Text variant="primary">
              {order.updated_at ? <LocalizedDate dateTime={order.updated_at} time /> : '-'}
            </ListLayout.Text>
          </ListLayout.Stack>
        </ListLayout.Column>
      </Card.Content>
    </Card.Wrapper>
  );
}
